import React from 'react';

import PodcasterFaqPage from '@components/pages/Podcaster/PodcasterFaqPage';

const PodcasterFaq = () => <PodcasterFaqPage />;

export default PodcasterFaq;
